import { render } from "./TableRefreshButton.vue?vue&type=template&id=351dd5e2&scoped=true"
import script from "./TableRefreshButton.vue?vue&type=script&lang=js"
export * from "./TableRefreshButton.vue?vue&type=script&lang=js"

import "./TableRefreshButton.vue?vue&type=style&index=0&id=351dd5e2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-351dd5e2"]])

export default __exports__